import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import { CURRENT_CAR_ANNOUNCEMENT_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useCurrentCarAnnouncementSocket'
import { useUpdateCar } from '@autobid/ui/composables/car/useUpdateCar'

export function useCurrentCarAnnouncementBidDeleted() {
  const { startListen } = useWebSocketStore()
  const { updateAnnouncementCarData } = useUpdateCar()

  const bidDeleted = () => {
    startListen({
      eventName: 'premium.BID_DELETED',
      callbackName: CURRENT_CAR_ANNOUNCEMENT_SOCKET_CALLBACK,
      callback: (event) => {
        const { auctionId, carId, price } = event.context

        updateAnnouncementCarData(auctionId, (item) => {
          if (!item) {
            return item
          }

          if (item.id !== carId) {
            return item
          }

          return {
            ...item,
            bids: item.bids.filter(bid => bid.amount !== price),
          }
        })
      },
    })
  }

  return { bidDeleted }
}
